
export const suggestedQuestionsText = 
`Do you detect any surveying errors?
Average the spillway shot elevations.
Show me the 10 most northern points.
Inverse between points 5 and 6
Draw the trails
List all survey control points.
Draw all points with hub in the description.
Draw the spillway points.
What is the elevation difference between pad 1 and pad 2
what is the pipe slope between 5399 and 5671
Create a cut sheet for points 515 (design elev 280.0) and 516 (design elev 272.0).`;